(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-hero-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('[data-lp-signup]');
  if (!form) return;

  var key  = form.getAttribute('data-klaviyo-key');
  var list = form.getAttribute('data-klaviyo-list');
  var btn  = form.querySelector('[data-lp-signup-btn]');
  var ok   = document.querySelector('[data-lp-signup-success]');
  var err  = document.querySelector('[data-lp-signup-error]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!key || !list) return;
    if (!form.reportValidity()) return;

    if (err) err.hidden = true;
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Sending…';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Blushield Webinar Page',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: form.email.value.trim(),
                first_name: form.first_name.value.trim(),
                last_name: form.last_name.value.trim(),
                properties: {
                  webinar_source: 'Blushield Webinar Page',
                  webinar_session_date: form.getAttribute('data-session-date') || '',
                  webinar_session_time: form.getAttribute('data-session-time') || ''
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      if (res.status !== 202) throw new Error('HTTP ' + res.status);
      form.hidden = true;
      if (ok) ok.hidden = false;
    })
    .catch(function () {
      btn.disabled = false;
      btn.innerHTML = original;
      if (err) err.hidden = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
